module.exports = function() {
  return new Worker(__webpack_public_path__ + "9c033b69644289806397.worker.js");
};